<script>
	const metadata = require('core/metadata');
	const _ = require('underscore');
	const sortByOrder = metadata.sortByOrder;

	module.exports = {
		props: {
			topic: {
				type: Number
			},
			onTopicClick: {
				default: function () {}
			},
			parentMap: {
				default: {}
			}
		},
		computed: {
			activeParent() {
				let currentTopic = this.topic;
				let node = currentTopic && metadata.allActiveNodesById['_' + currentTopic];
				let parentId = node && node.parentId;
				return parentId && parentId !== metadata.domainNode.id ? parentId : node && node.id;
			},
			activeChild() {
				let currentTopic = this.topic;
				let node = currentTopic && metadata.allActiveNodesById['_' + currentTopic];
				return currentTopic && node ? node.id : null;
			},
			activeTopic() {
				let activeParent = this.activeParent;
				let activeChild = this.activeChild;
				return activeChild || activeParent;
			},
			topicList() {
				let keys = Object.keys(this.parentMap)
					.map(k => this.parentMap[k])
					.sort(sortByOrder)
					.map(p => p.id);
				let activeParent = this.activeParent;
				let list = keys.map(k => {
					let dataNode = metadata.allActiveNodesById['_' + k];
					let node = _.assign({}, dataNode);
					if (!activeParent || k !== activeParent) {
						node = _.assign({}, dataNode, {
							children: undefined
						});
					} else if (this.parentMap[k].filter) {
						let filter = this.parentMap[k].filter;
						node.children = node.children.filter(filter);
					}
					if (node.children) {
						node.children.sort(sortByOrder);
					}
					return node;
				}); //.sort(sortByOrder); // Add back when order driven by Dante
				return list;
			}
		},
		methods: {
			onCaretClick() {
				if (this.topic) {
					this.onTopicClick();
				}
			},
			onTopicClickLocal(topic) {
				let currentTopic = this.topic;
				let parentMap = this.parentMap;
				let node = metadata.allActiveNodesById['_' + topic];
				let id = node.id;
				let parentId = node.parentId;

				if ((node.parentId === metadata.domainNode.id || !parentId) && currentTopic === id) {
					// click already filtered parent - collapse menu
					topic = null;
				} else if ((!parentId || parentId === metadata.domainNode.id) && parentMap[id] && !parentMap[id].allowParentFilter) {
					// Don't allow parent filtering - select first child
					if (node && node.children && node.children.length) {
						let children = node.children.slice() || [];
						if (parentMap[id].filter) {
							children = children.filter(parentMap[id].filter);
						}
						children.sort(sortByOrder);
						if (children && children.length) {
							topic = children[0].id;
						}
					}
				}

				this.onTopicClick(topic);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/flexbox';

	.topic-selector {
		.topic-family > .topic.label {
			cursor: pointer;

			&.active {
				color: $c-blue;
			}

			&.child-topic {
				margin-left: 1.75rem;
			}

			i {
				min-width: 1rem;
			}
		}
	}
</style>
<template>
	<div class="topic-selector">
		<div
			v-for="topic in topicList"
			:key="topic.id"
			class="topic-family">
			<div
				class="topic label parent-topic"
				:class="{
					active: activeTopic === topic.id
				}"
				@click="onTopicClickLocal(topic.id)">
				<i
					class="fa-solid"
					@click="onCaretClick"
					:class="{
						'fa-angle-right': activeParent !== topic.id,
						'fa-angle-down': activeParent === topic.id
					}"
					aria-hidden="true"></i>
				{{ topic.name }}
			</div>
			<template v-if="topic && topic.children">
				<div
					v-for="child in topic.children"
					:key="child.id"
					class="topic label child-topic"
					:class="{
						active: activeTopic === child.id
					}"
					@click="onTopicClickLocal(child.id)">
					{{ child.name }}
				</div>
			</template>
		</div>
	</div>
</template>
